import { defaultBorder, defaultBorderRadius, defaultInputHeight, defaultLineHeight, lightGreyColor, weightGreyColor } from '@config/styledVar';
import React from 'react';
import style from 'react-syntax-highlighter/styles/hljs/agate';

const EmptyLine: React.FC<{
  text?: string;
  noBorder?: boolean;
  height?: number;
  onClick?: () => void;
  style?: React.CSSProperties;
}> = ({ noBorder, height, text, onClick, style }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingLeft: 16,
        height: height ?? defaultLineHeight,
        backgroundColor: 'inherit',
        color: lightGreyColor,
        border: noBorder ? 'none' : defaultBorder,
        borderRadius: defaultBorderRadius,
        cursor: onClick ? 'pointer' : 'inherit',
        ...style
      }}
      onClick={onClick}
    >
      {text ?? 'No data'}
    </div>
  );
};

export default EmptyLine;
